import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import type { addMemberToOrgSchema } from "backend/src/schemas/organisationSchema";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { UserType } from "../query/useCurrentUserQuery";
import { QUERY_KEYS } from "../query/querykeys";

type OrgAddMemberResponseType = ResponseType<UserType>;

function useAddOrganisationMemberMutation(organisationId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<OrgAddMemberResponseType>["response"],
    AxiosResponseAndError<OrgAddMemberResponseType>["error"],
    z.infer<typeof addMemberToOrgSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.post<OrgAddMemberResponseType>(`${requestURLs.organisation}/${organisationId}/user`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.teamUnits] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.jobTitles] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.contractTypes] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.organisation] });
    },
  });

  return mutation;
}

export default useAddOrganisationMemberMutation;
